module.exports = __webpack_public_path__ + "media/images/requisitions/yd_bg-5f4ac106ddd9004137b943d5e0bb294c.png";